import Button from '@mui/material/Button'
import usePostStripeStartCheckout from 'app/hooks/subscription/usePostStripeStartCheckout'

//Just stubbing out for now
export default function PaymentCheckoutPlan({items}: {items: any[]}) {
  const [exec, {data, loading, error}] = usePostStripeStartCheckout()

  const handleCheckout = async () => {
    //array must be length of 1 for now
    if (items.length !== 1) {
      toastr.error('An error occurred on checkout')
      return
    }
    const item = items[0]
    const id = item?.plan.id
    const quantity = item.seat_quantity
    exec(
      {id, quantity},
      {
        onComplete: (url: string) => {
          if (url) {
            window.location.href = url
          }
        },
        onError: (error: any) => {
          toastr.error('An error occurred on checkout')
        },
      }
    )
  }

  return (
    <div className='App'>
      <Button
        onClick={handleCheckout}
        variant={'contained'}
        size='small'
        sx={{
          color: 'black',
          textTransform: 'none',
          fontWeight: 400,
          width: '250px',
          background: '#ffd814',
          borderColor: '#fcd200',
          borderRadius: '100px',
          '&:hover': {
            bgcolor: '#ffd814',
            borderColor: '#fcd200',
          },
        }}
      >
        Proceed To Checkout
      </Button>
    </div>
  )
}
